import React, { useEffect, useState } from "react";
import moment from "moment";
import AppsIcon from '@mui/icons-material/Apps';
import { Button, ListItemText, Menu, MenuItem } from '@mui/material';
import { useLocation, useNavigate } from "react-router-dom";
import { logFeatureUsage } from "../../../fetch/insightsHelper";
import { useAppMenu } from "../../../fetch/configurationFetch";
import { useDispatch, useSelector } from "react-redux";
import { useIsAuthenticated } from "@azure/msal-react";
import { fetchPermissions } from "../../../redux/permissionsSlice";
import { msalInstance } from "../../..";

export default function AppMenu({ spMode }) {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const isAuthenticated = useIsAuthenticated();
    const location = useLocation();
    const [anchorEl, setAnchorEl] = useState(null);
    const open = !!anchorEl;
    const permissions = useSelector((state) => state.permissions);
    const { isLoaded, hasServiceLog, hasRatesCalculator } = permissions;

    const isExpired = () => {
        const account = msalInstance.getActiveAccount();
        if (!!account && !!account.idTokenClaims &&
            new Date(account.idTokenClaims.exp * 1000) > new Date()) {
             
            // Instead of strictly checking for expiration, we check if the token is about to expire within the next minute. This is to avoid edge cases where the token might be valid for a very short time.
            var currentTime = moment().add('1', 'm');
            var expireTimeMoment = moment(account.idTokenClaims.exp * 1000);
            // console.log(expireTimeMoment.diff(currentTime, 'minutes') + ' minutes till expiration');
            if (expireTimeMoment.diff(currentTime, 'minutes') > 0) {
                return false
            }
        }

        return true;
    }

    useEffect(() => {
        // console.log({isAuthenticated, isLoaded, isExpired: isExpired()});

        if (isAuthenticated && !isLoaded && !isExpired()) {
            dispatch(fetchPermissions());
        }
    }, [isAuthenticated, isLoaded]);

    const { data: appMenuData } = useAppMenu();

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    return (<>
        <Button
            id="app-menu-button"
            aria-controls={open ? 'app-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}
            onClick={handleClick}
            variant='outline'
            style={{ marginLeft: !spMode ? '-16px' : '40px' }}
        >
            <AppsIcon />
        </Button>
        <Menu
            id="app-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            slotProps={{
                list: {
                    'aria-labelledby': 'app-menu-button',
                },
            }}
        >
            {appMenuData && appMenuData.map((menuItem, index) => {
                if (!hasServiceLog && menuItem.featureLogKey === 'AppMenuServiceLog') {
                    return null;
                }
                if (!hasRatesCalculator && (menuItem.featureLogKey === 'AppMenuOutboardRates' || menuItem.featureLogKey === 'AppMenuMerCruiserRates')) {
                    return null;
                }

                let positiveMatch = true;
                if (!!menuItem.positiveSelectedPathSegment) {
                    positiveMatch = location.pathname.indexOf(menuItem.positiveSelectedPathSegment) >= 0;
                }
                let negativeMatch = false;
                if (!!menuItem.negativeSelectedPathSegment && menuItem.negativeSelectedPathSegment.length > 0) {
                    negativeMatch = menuItem.negativeSelectedPathSegment.filter(item => location.pathname.indexOf(item) >= 0).length > 0;
                }

                return (
                    <MenuItem
                        key={index}
                        onClick={() => {
                            navigate(menuItem.navigateUrl);
                            logFeatureUsage(menuItem.featureLogKey);
                            handleClose();
                        }}
                        style={{ margin: 8 }}
                        selected={positiveMatch && !negativeMatch}
                    >
                        <ListItemText>{menuItem.displayText}</ListItemText>
                    </MenuItem>
                );
            })}
        </Menu>
    </>
    );
}